import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Alert, AlertDescription, AlertTitle, Button } from "../../../components/base";
import { useUiTranslation } from "../../../i18n";
import { cn } from "../../../lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger, } from "../overlays/PortalTooltip";
export const TurnErrorNotice = ({ className, status, error, retryable = true, isAsking = false, disabled = false, disabledTooltipContent, onRegenerate, }) => {
    const { t } = useUiTranslation();
    // Log full error details for debugging (not displayed to user)
    useEffect(() => {
        if (error) {
            console.warn("[TurnErrorNotice] Assistant response error:", {
                status,
                code: error.code,
                message: error.message,
                at: error.at,
            });
        }
    }, [status, error]);
    // Get user-friendly message based on status
    const getMessageByStatus = (status) => {
        switch (status) {
            case "timeout":
                return t("chat.turnError.timeout", "Request timed out. Please try again.");
            case "cancelled":
                return t("chat.turnError.cancelled", "Request was cancelled.");
            case "failed":
            default:
                return t("chat.turnError.message", "Failed to get AI response. Please try again.");
        }
    };
    const isContentFiltered = error?.code === "LLM_CONTENT_FILTER";
    const shouldShowRegenerate = !isContentFiltered && retryable !== false && !!onRegenerate;
    const isDisabled = isAsking || disabled;
    const errorMessage = isContentFiltered
        ? t("chat.turnError.contentFilter", "AI could not answer this request due to a content restriction.")
        : getMessageByStatus(status);
    const errorCode = error?.code;
    return (_jsxs(Alert, { className: cn("mt-3", className), "data-testid": "turn-error-notice", children: [_jsx(AlertTitle, { className: "text-red-700", children: t("chat.turnError.title", "This response failed") }), _jsx(AlertDescription, { children: _jsxs("div", { className: "flex flex-col gap-2", children: [_jsxs("span", { className: "text-shadow-destructive", children: [errorMessage, errorCode && (_jsxs("span", { className: "text-xs text-muted-foreground ml-2", children: ["(", errorCode, ")"] }))] }), shouldShowRegenerate &&
                            (() => {
                                const button = (_jsx(Button, { type: "button", variant: "secondary", size: "sm", onClick: onRegenerate, disabled: isDisabled, "data-testid": "turn-error-regenerate", children: t("chat.turnError.retry", "Regenerate") }));
                                if (isDisabled && disabledTooltipContent) {
                                    return (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx("span", { tabIndex: 0, className: "inline-block", children: button }) }), _jsx(TooltipContent, { children: disabledTooltipContent })] }));
                                }
                                return button;
                            })()] }) })] }));
};
//# sourceMappingURL=TurnErrorNotice.js.map